/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Перечисление, определяющее тип цели для квеста.
 * @export
 * @enum {string}
 */
export var FxIdDomainCrossPlayQuestTargetType;
(function (FxIdDomainCrossPlayQuestTargetType) {
    FxIdDomainCrossPlayQuestTargetType[FxIdDomainCrossPlayQuestTargetType["Unspecified"] = 0] = "Unspecified";
    FxIdDomainCrossPlayQuestTargetType[FxIdDomainCrossPlayQuestTargetType["CurrentValue"] = 1] = "CurrentValue";
    FxIdDomainCrossPlayQuestTargetType[FxIdDomainCrossPlayQuestTargetType["CumulativeValue"] = 2] = "CumulativeValue";
    FxIdDomainCrossPlayQuestTargetType[FxIdDomainCrossPlayQuestTargetType["EventCount"] = 3] = "EventCount";
    FxIdDomainCrossPlayQuestTargetType[FxIdDomainCrossPlayQuestTargetType["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainCrossPlayQuestTargetType || (FxIdDomainCrossPlayQuestTargetType = {}));
export function instanceOfFxIdDomainCrossPlayQuestTargetType(value) {
    for (const key in FxIdDomainCrossPlayQuestTargetType) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainCrossPlayQuestTargetType, key)) {
            if (FxIdDomainCrossPlayQuestTargetType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainCrossPlayQuestTargetTypeFromJSON(json) {
    return FxIdDomainCrossPlayQuestTargetTypeFromJSONTyped(json, false);
}
export function FxIdDomainCrossPlayQuestTargetTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainCrossPlayQuestTargetTypeToJSON(value) {
    return value;
}
export function FxIdDomainCrossPlayQuestTargetTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainCrossPlayQuestTargetType.js.map